<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0 index-3">

    <div class="d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" [routerLink]="['/']"></i>

        <a class="text-white f18 my-auto d-flex align-items-center">

            <i class="fa fa-question-circle my-auto me-2 fa-2x pointer"></i>

            داشبورد شیلات نگر

        </a>

    </div>

</div>

<div class="col-12 row gx-0 gy-0 bg-th-blue border-top dirI border border-2">

    <div class="col-md-3 col-9 p-2">

        <select class="form-select" id="domainDashbord" [(ngModel)]="iMobileDomain">

            <option value="-1"> حوزه خدمت را انتخاب کنید </option>

            <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
            
        </select>
    </div>

    <div class="col-md-3 col-9 p-2">

        <select id="carGroup" class="form-select" [(ngModel)]="tiMobileType">

            <option value="-1">نوع شناور را انتخاب کنید</option>

            <option *ngFor="let item of groupCar" value="{{item.tiMobileType}}">{{item.strComment}}</option>

        </select>

    </div>

    <div class="col-md-3 col-9 p-2 ">

        <button class="btn btn-primary" (click)="search()">

            به روز رسانی

            <i class="fa fa-search"></i>

        </button>

    </div>

</div>

<div class="d-flex justify-content-around flex-wrap mt-4">

    <!-- تعداد شناورها  به تفکیک توان -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="">

            <p class="text-center f18 "> تعداد شناورها به تفکیک توان </p>

            <canvas id="myChart3" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- پر مصرف ترین شناورها -->

    <div id="chart1" class="col-md-11 col-12 justify-content-around d-flex row chart2 rounded shadow mb-5">

        <div class="">

            <p class="text-center f18 dirI"> پر مصرف ترین شناورها </p>

            <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- پر عملکردترین شناورها  -->

    <div id="chart2" class="col-md-11 col-12 justify-content-around d-flex row chart2 rounded shadow mb-5">

        <div class="">

            <p class="text-center f18 dirI"> پر عملکردترین شناورها </p>

            <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- وضعیت شناورها -->

    <div class="col-md-11 col-12">

        <p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%"> وضعیت شناورها </p>

        <div echarts [autoResize]="true" [options]="options | async" id="totalVehicles" class="tree-chart border-bottom"></div>

    </div>

    <!-- شناورها به تفکیک محدوده جغرافیایی -->

    <div class="col-md-11 col-12">

        <p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%"> شناورها به تفکیک محدوده جغرافیایی </p>

        <div echarts [autoResize]="true" [options]="options1 | async" id="orgVehiclesStatus" class="tree-chart border-bottom"></div>

    </div>

    <!-- نقشه پراکندگی شناورها -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="d-flex justify-content-center flex-wrap">

            <div class="col-12 mt-3">

                <h3 class="text-center "> نقشه پراکندگی شناورها </h3>

            </div>

            <div class=" col-md-8 col-10 mb-5 border rounded-3 border-3 border-success mt-2">

                <div id="test" class="fixed-mapCluster">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>